import type { MouseEvent } from 'react'

import clsx from 'clsx'
import { Link } from 'react-router-dom'

import { statusToCN } from '../../const'

const notPropagate = (e: MouseEvent) => e.stopPropagation()

interface Step {
	id: number
	name: string
}

// TODO: replace `.add-contacts-button-team` into separate component. Combine with `<Button />` component

export function SubInfo({
	id,
	statistics,
	status,
	steps,
	target_audience_count: audienceCount
}: {
	id: string
	statistics: {
		in_queue_count: number
		started_count: number
	}

	status: keyof typeof statusToCN
	steps: Step[]
	target_audience_count: number
}) {
	return status !== 'Compose' ? (
		<div className='flex-container-performed-progress-campaigns'>
			<div className='performed-progress-campaigns'>
				<div
					className={clsx('performed-bar', statusToCN[status])}
					style={{
						width: `${
							statistics.started_count && audienceCount
								? (statistics.started_count / audienceCount) * 100
								: '0'
						}%`
					}}
				>
					&nbsp;
				</div>
			</div>

			<div className='performed-bar-value'>
				<div className='performed-bar-text'>{statistics.started_count}</div>
				<div className='performed-bar-text'>{statistics.in_queue_count}</div>
			</div>
		</div>
	) : (
		<div className='flex-container-team-statistics'>
			<div className='contacts-count'>
				{audienceCount ? (
					`Contacts: ${audienceCount}`
				) : (
					<Link
						className='add-contacts-button-team'
						onClick={notPropagate}
						to={`/campaigns/${id}/contacts`}
					>
						Add contacts
					</Link>
				)}
			</div>
			<div>
				{steps.length === 0 ? (
					<Link
						className='add-contacts-button-team'
						onClick={notPropagate}
						to={`/campaigns/${id}/tune`}
					>
						Add actions
					</Link>
				) : (
					<div className='contacts-count'>
						{`${steps[0].name} `}
						{steps.length - 1 > 0 ? `(+${steps.length - 1})` : ''}
					</div>
				)}
			</div>
		</div>
	)
}
